import { ExtensionsClient } from "./extensions.js";
/** Mosque profile, events and RSVPs. Public reads/RSVP; writes need content:write. */
export class MosqueClient extends ExtensionsClient {
    /** Public. Browsers revalidate with the response ETag automatically. */
    async getMosque(slug) {
        return this.request("GET", `${this.siteBase(slug)}/mosque`);
    }
    /** Replace the whole profile. `ifMatch` is an ETag from a previous read (412 when stale). */
    async putMosque(slug, input, ifMatch) {
        return this.request("PUT", `${this.siteBase(slug)}/mosque`, input, true, false, ifMatchHeader(ifMatch));
    }
    /** RFC 7386 merge patch: `null` deletes a key, objects merge, arrays replace. */
    async patchMosque(slug, patch, ifMatch) {
        return this.request("PATCH", `${this.siteBase(slug)}/mosque`, patch, true, false, ifMatchHeader(ifMatch));
    }
    /**
     * Platform admin only (403 for every tenant role): set or clear the "verified" badge on a site's
     * donation config. 400 when the site has no donation causes. A mosque edit that changes where
     * donors are sent (hosts, cause ids or links) clears the badge again.
     */
    async setMosqueDonationVerified(slug, verified) {
        return this.request("PUT", `${this.siteBase(slug)}/mosque/donation/verified`, { verified }, true);
    }
    /** Public upcoming feed (urgent first, then events by start, then news). */
    async listMosqueEvents(slug, query = {}) {
        const q = MosqueClient.query({ limit: query.limit, offset: query.offset });
        return this.request("GET", `${this.siteBase(slug)}/mosque/events${q}`);
    }
    /** Staff feed including expired and past items (content:write). */
    async listMosqueEventsStaff(slug, query = {}) {
        const q = MosqueClient.query({ limit: query.limit, offset: query.offset, includeExpired: "true" });
        return this.request("GET", `${this.siteBase(slug)}/mosque/events${q}`, undefined, true);
    }
    async createMosqueEvent(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/mosque/events`, input, true);
    }
    async updateMosqueEvent(slug, id, patch) {
        return this.request("PATCH", `${this.siteBase(slug)}/mosque/events/${encodeURIComponent(id)}`, patch, true);
    }
    async deleteMosqueEvent(slug, id) {
        await this.request("DELETE", `${this.siteBase(slug)}/mosque/events/${encodeURIComponent(id)}`, undefined, true);
    }
    /**
     * Public RSVP. `idempotencyKey` (8-128 chars) makes retries safe: the same key
     * returns the original RSVP with `replayed: true` instead of adding seats.
     * 409 `event_full` / `rsvp_closed`, 429 `rate_limited`.
     */
    async rsvpMosqueEvent(slug, id, input, idempotencyKey) {
        return this.request("POST", `${this.siteBase(slug)}/mosque/events/${encodeURIComponent(id)}/rsvp`, input, false, false, { "Idempotency-Key": idempotencyKey });
    }
    /** Staff view of an event's reservations (first name + count only). */
    async listMosqueRsvps(slug, id) {
        return this.request("GET", `${this.siteBase(slug)}/mosque/events/${encodeURIComponent(id)}/rsvps`, undefined, true);
    }
}
function ifMatchHeader(etag) {
    return etag ? { "If-Match": etag } : undefined;
}
//# sourceMappingURL=mosque.js.map